import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getAdminRole } from "../utils/auth";
import { hasAccess } from "../utils/permissions";
import { fetchStats } from "../utils/supportApi";
import { Box, Drawer, List, ListItemButton, ListItemIcon, ListItemText, Typography, Badge, } from "@mui/material";
import { Restaurant as RecipesIcon, ShoppingCart as ProductsIcon, LocalDining as IngredientsIcon, LocalCafe as CafesIcon, RestaurantMenu as CafeMenuItemsIcon, Receipt as OrdersIcon, Person as UsersIcon, Search as SearchIcon, Category as SearchConceptsIcon, Warning as WarningIcon, AutoAwesome as AutoAwesomeIcon, Campaign as BloggerIcon, EmojiFoodBeverage as DietaryTagsIcon, Label as TagsIcon, LocalOffer as PromoCodesIcon, Assessment as StatisticsIcon, Pin as ShortCodesIcon, EmojiEvents as AchievementsIcon, CardMembership as SubscriptionsIcon, TrendingUp as SituationalRatingsIcon, MonitorHeart as CatalogHealthIcon, RocketLaunch as OnboardingIcon, SupportAgent as SupportIcon, NotificationsActive as BroadcastsIcon, } from "@mui/icons-material";
import Logo from "./Logo";
import { SIDEBAR_WIDTH } from "../theme/theme";
// Двадцать с лишним пунктов сплошным списком не читаются — группируем по
// смыслу работы: каталог, заведения, люди, продуктовые механики, операции.
const GROUPS = [
    {
        title: "Каталог",
        tabs: [
            {
                id: "recipes",
                label: "Рецепты",
                icon: _jsx(RecipesIcon, {}),
                path: "/recipes",
                resource: "recipes",
            },
            {
                id: "generate-recipes",
                label: "Генерация рецептов",
                icon: _jsx(AutoAwesomeIcon, {}),
                path: "/generate-recipes",
                resource: "generate-recipes",
            },
            {
                id: "products",
                label: "Продукты",
                icon: _jsx(ProductsIcon, {}),
                path: "/products",
                resource: "products",
            },
            {
                id: "products-without-nutrition",
                label: "Продукты без КБЖУ",
                icon: _jsx(WarningIcon, {}),
                path: "/products/without-nutrition",
                resource: "products",
            },
            {
                id: "ingredients",
                label: "Ингредиенты",
                icon: _jsx(IngredientsIcon, {}),
                path: "/ingredients",
                resource: "ingredients",
            },
            {
                id: "tags",
                label: "Теги",
                icon: _jsx(TagsIcon, {}),
                path: "/tags",
                resource: "tags",
            },
            {
                id: "tag-generation",
                label: "Генерация тегов",
                icon: _jsx(AutoAwesomeIcon, {}),
                path: "/tag-generation",
                resource: "tags",
            },
            {
                id: "dietary-tags",
                label: "Диетические теги",
                icon: _jsx(DietaryTagsIcon, {}),
                path: "/dietary-tags",
                resource: "dietary-tags",
            },
            {
                id: "catalog-health",
                label: "Здоровье каталога",
                icon: _jsx(CatalogHealthIcon, {}),
                path: "/catalog-health",
                resource: "catalog-health",
            },
        ],
    },
    {
        title: "Кафе",
        tabs: [
            {
                id: "cafes",
                label: "Кафе",
                icon: _jsx(CafesIcon, {}),
                path: "/cafes",
                resource: "cafes",
            },
            {
                id: "cafe-menu-items",
                label: "Блюда из кафе",
                icon: _jsx(CafeMenuItemsIcon, {}),
                path: "/cafe-menu-items",
                resource: "cafe-menu-items",
            },
        ],
    },
    {
        title: "Пользователи",
        tabs: [
            {
                id: "users",
                label: "Пользователи",
                icon: _jsx(UsersIcon, {}),
                path: "/users",
                resource: "users",
            },
            {
                id: "support",
                label: "Поддержка",
                icon: _jsx(SupportIcon, {}),
                path: "/support",
                resource: "support",
            },
            {
                id: "push-broadcasts",
                label: "Пуш-рассылки",
                icon: _jsx(BroadcastsIcon, {}),
                path: "/push-broadcasts",
                resource: "push-broadcasts",
            },
            {
                id: "subscriptions",
                label: "Подписки",
                icon: _jsx(SubscriptionsIcon, {}),
                path: "/subscriptions",
                resource: "subscriptions",
            },
            {
                id: "promo-codes",
                label: "Промокоды",
                icon: _jsx(PromoCodesIcon, {}),
                path: "/promo-codes",
                resource: "promo-codes",
            },
            {
                id: "bloggers",
                label: "Блогеры",
                icon: _jsx(BloggerIcon, {}),
                path: "/bloggers",
                resource: "bloggers",
            },
            {
                id: "short-codes",
                label: "Коды авторизации",
                icon: _jsx(ShortCodesIcon, {}),
                path: "/short-codes",
                resource: "short-codes",
            },
        ],
    },
    {
        title: "Продукт",
        tabs: [
            {
                id: "onboarding",
                label: "Онбординг",
                icon: _jsx(OnboardingIcon, {}),
                path: "/onboarding",
                resource: "onboarding",
            },
            {
                id: "achievements",
                label: "Достижения",
                icon: _jsx(AchievementsIcon, {}),
                path: "/achievements",
                resource: "achievements",
            },
            {
                id: "situational-ratings",
                label: "Ситуативные рейтинги",
                icon: _jsx(SituationalRatingsIcon, {}),
                path: "/situational-ratings",
                resource: "situational-ratings",
            },
            {
                id: "search-synonyms",
                label: "Синонимы поиска",
                icon: _jsx(SearchIcon, {}),
                path: "/search-synonyms",
                resource: "search-synonyms",
            },
            {
                id: "search-concepts",
                label: "Понятийный поиск",
                icon: _jsx(SearchConceptsIcon, {}),
                path: "/search-concepts",
                resource: "search-concepts",
            },
        ],
    },
    {
        title: "Операции",
        tabs: [
            {
                id: "vkusvill-orders",
                label: "Заказы Вкусвилл",
                icon: _jsx(OrdersIcon, {}),
                path: "/vkusvill-orders",
                resource: "vkusvill-orders",
            },
            {
                id: "statistics",
                label: "Статистика",
                icon: _jsx(StatisticsIcon, {}),
                path: "/statistics",
                resource: "statistics",
            },
        ],
    },
];
// Путь до текущего раздела для шапки — берём из того же справочника, чтобы
// название в меню и в шапке не разъезжались
export function getSectionPath(pathname) {
    let best = [];
    let bestLength = 0;
    for (const group of GROUPS) {
        for (const tab of group.tabs) {
            const matches = pathname === tab.path || pathname.startsWith(`${tab.path}/`);
            if (matches && tab.path.length > bestLength) {
                best = [group.title, tab.label];
                bestLength = tab.path.length;
            }
        }
    }
    return best;
}
const SUPPORT_POLL_INTERVAL_MS = 30000;
const Sidebar = () => {
    const location = useLocation();
    const role = getAdminRole();
    // Точка на пункте меню: сколько обращений ждут ответа прямо сейчас
    const [unansweredCount, setUnansweredCount] = useState(0);
    useEffect(() => {
        if (!hasAccess(role, "support")) {
            return;
        }
        let cancelled = false;
        const load = () => {
            void fetchStats()
                .then((stats) => {
                if (!cancelled) {
                    setUnansweredCount(stats.unanswered);
                }
            })
                .catch(() => {
                // молчим: бейдж — необязательная деталь
            });
        };
        load();
        // eslint-disable-next-line no-undef
        const timer = setInterval(load, SUPPORT_POLL_INTERVAL_MS);
        return () => {
            cancelled = true;
            // eslint-disable-next-line no-undef
            clearInterval(timer);
        };
    }, [role]);
    // Группа целиком исчезает, если роли недоступен ни один её пункт
    const groups = useMemo(() => {
        const visible = [];
        for (const group of GROUPS) {
            const tabs = group.tabs.filter((tab) => hasAccess(role, tab.resource));
            if (tabs.length > 0) {
                visible.push({ title: group.title, tabs });
            }
        }
        return visible;
    }, [role]);
    return (_jsxs(Drawer, { variant: "permanent", sx: {
            width: SIDEBAR_WIDTH,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
                width: SIDEBAR_WIDTH,
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
            },
        }, children: [_jsx(Box, { sx: { px: 2.5, py: 2.5 }, children: _jsx(Logo, {}) }), _jsx(Box, { sx: { flex: 1, overflowY: "auto", px: 1, pb: 2 }, children: groups.map((group) => (_jsxs(Box, { sx: { mb: 1.5 }, children: [_jsx(Typography, { variant: "overline", sx: {
                                display: "block",
                                px: 1.5,
                                mb: 0.5,
                                fontSize: 10.5,
                                color: "text.secondary",
                            }, children: group.title }), _jsx(List, { disablePadding: true, sx: { display: "grid", gap: 0.25 }, children: group.tabs.map((tab) => {
                                const selected = location.pathname === tab.path ||
                                    location.pathname.startsWith(`${tab.path}/`);
                                return (_jsxs(ListItemButton, { component: Link, to: tab.path, selected: selected, sx: { py: 0.75, px: 1.5 }, children: [_jsx(ListItemIcon, { sx: {
                                                minWidth: 34,
                                                color: selected ? "primary.main" : "text.secondary",
                                                "& svg": { fontSize: 20 },
                                            }, children: tab.id === "support" ? (_jsx(Badge, { color: "error", variant: "dot", invisible: unansweredCount === 0, children: tab.icon })) : (tab.icon) }), _jsx(ListItemText, { primary: tab.label, slotProps: {
                                                primary: {
                                                    fontSize: 14,
                                                    fontWeight: selected ? 700 : 500,
                                                    noWrap: true,
                                                },
                                            } })] }, tab.id));
                            }) })] }, group.title))) })] }));
};
export default Sidebar;
